(() => {
  const setAccordionState = (item, open) => {
    const button = item.querySelector('[data-ea-faq-toggle]');
    const panel = item.querySelector('[data-ea-faq-panel]');
    if (!button || !panel) return;

    item.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  };

  document.querySelectorAll('[data-ea-faq-root]').forEach((root) => {
    const onlyOneOpen = root.getAttribute('data-ea-faq-only-one-open') === 'true';
    const items = Array.from(root.querySelectorAll('[data-ea-faq-item]'));
    const chips = Array.from(root.querySelectorAll('[data-ea-faq-chip]'));
    const categorySections = Array.from(root.querySelectorAll('[data-ea-faq-category]'));
    const searchInput = root.querySelector('[data-ea-faq-search-input]');
    const noResults = root.querySelector('[data-ea-faq-no-results]');

    const closeOtherItems = (activeItem) => {
      if (!onlyOneOpen) return;
      items.forEach((item) => {
        if (item !== activeItem) setAccordionState(item, false);
      });
    };

    // Search spans EVERY category. When a term is present, every category that
    // has a hit is shown (with only its matching questions); the active-category
    // filter only applies when the search box is empty.
    const applyFilters = () => {
      const activeCategory = root.getAttribute('data-ea-faq-active-category') || 'the_object';
      const searchTerm = (searchInput?.value || '').trim().toLowerCase();
      const searching = searchTerm.length > 0;
      let totalVisible = 0;

      categorySections.forEach((section) => {
        const sectionKey = section.getAttribute('data-ea-faq-category');
        const sectionItems = Array.from(section.querySelectorAll('[data-ea-faq-item]'));
        const emptyMessage = section.querySelector('[data-ea-faq-category-empty]');
        let visibleCount = 0;

        sectionItems.forEach((item) => {
          const question = (item.getAttribute('data-ea-faq-question') || '').toLowerCase();
          const answer = (item.getAttribute('data-ea-faq-answer') || '').toLowerCase();
          const isMatch = !searching || question.includes(searchTerm) || answer.includes(searchTerm);

          item.hidden = !isMatch;
          if (isMatch) visibleCount += 1;
        });

        if (searching) {
          section.hidden = visibleCount === 0;
        } else {
          section.hidden = sectionKey !== activeCategory;
        }

        if (!section.hidden) totalVisible += visibleCount;

        // The per-category "no match" line is superseded by the global one.
        if (emptyMessage) emptyMessage.hidden = true;
      });

      root.classList.toggle('is-searching', searching);
      if (noResults) noResults.hidden = !(searching && totalVisible === 0);
    };

    const applyCategory = (categoryKey) => {
      root.setAttribute('data-ea-faq-active-category', categoryKey);

      chips.forEach((chip) => {
        const chipKey = chip.getAttribute('data-ea-faq-chip');
        const isActive = chipKey === categoryKey;
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      applyFilters();
    };

    items.forEach((item) => {
      const button = item.querySelector('[data-ea-faq-toggle]');
      if (!button) return;

      setAccordionState(item, false);

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          setAccordionState(item, false);
          return;
        }

        closeOtherItems(item);
        setAccordionState(item, true);

        if (item.id) {
          history.replaceState({}, '', `#${item.id}`);
        }
      });
    });

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const categoryKey = chip.getAttribute('data-ea-faq-chip');
        if (!categoryKey) return;
        // Choosing a category resets an active search so the section shows.
        if (searchInput) searchInput.value = '';
        applyCategory(categoryKey);
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        applyFilters();
      });
    }

    const openFromHash = () => {
      const hash = decodeURIComponent(window.location.hash.replace('#', ''));
      if (!hash) return;
      const item = document.getElementById(hash);
      if (!item || !item.hasAttribute('data-ea-faq-item') || !root.contains(item)) return;

      if (searchInput) searchInput.value = '';

      const categorySection = item.closest('[data-ea-faq-category]');
      const categoryKey = categorySection ? categorySection.getAttribute('data-ea-faq-category') : '';
      if (categoryKey) applyCategory(categoryKey);

      closeOtherItems(item);
      setAccordionState(item, true);
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const defaultCategory = root.getAttribute('data-ea-faq-default-category') || 'the_object';
    applyCategory(defaultCategory);
    openFromHash();

    window.addEventListener('hashchange', openFromHash);
    window.addEventListener('resize', () => {
      if (searchInput && searchInput.value.trim()) {
        applyFilters();
        return;
      }
      const currentCategory = root.getAttribute('data-ea-faq-active-category') || defaultCategory;
      applyCategory(currentCategory);
    });
  });
})();
